import React from 'react';
import { Role } from '../../consts';
import loadable from '@loadable/component';

interface Props {
    role: Role;
    languageCode: string;
}

const LoggedOutLogoEN = loadable(() => import('../Logos/99DesignsByVpWordmarkEn'));
const LoggedOutLogoDE = loadable(() => import('../Logos/99DesignsByVpWordmarkDe'));
const LoggedOutLogoIT = loadable(() => import('../Logos/99DesignsByVpWordmarkIt'));
const LoggedOutLogoPT = loadable(() => import('../Logos/99DesignsByVpWordmarkPt'));
const LoggedOutLogoFR = loadable(() => import('../Logos/99DesignsByVpWordmarkFr'));
const LoggedOutLogoNL = loadable(() => import('../Logos/99DesignsByVpWordmarkNl'));
const LoggedOutLogoES = loadable(() => import('../Logos/99DesignsByVpWordmarkEs'));

const LoggedInLogoEN = loadable(() => import('../Logos/99DesignsByVpSquaremarkEn'));
const LoggedInLogoDE = loadable(() => import('../Logos/99DesignsByVpSquaremarkDe'));
const LoggedInLogoIT = loadable(() => import('../Logos/99DesignsByVpSquaremarkIt'));
const LoggedInLogoPT = loadable(() => import('../Logos/99DesignsByVpSquaremarkPt'));
const LoggedInLogoFR = loadable(() => import('../Logos/99DesignsByVpSquaremarkFr'));
const LoggedInLogoNL = loadable(() => import('../Logos/99DesignsByVpSquaremarkNl'));
const LoggedInLogoES = loadable(() => import('../Logos/99DesignsByVpSquaremarkEs'));

export default function Logo({ role, languageCode = 'en' }: Props) {
    const homeUrl = role === 'contest-holder' ? '/work' : '/';
    const LogoComponent =
        role === 'logged-out' ? getLoggedOutLogo(languageCode) : getLoggedInLogo(languageCode);

    return (
        <div className="site-header__item site-header__item--branding">
            <a
                className="site-header__site-logo"
                href={homeUrl}
                title={__('99designs by Vistaprint')}
            >
                <div
                    className={`site-header__site-logo__image site-header__site-logo__image--${languageCode}`}
                    aria-label={__('99designs by Vistaprint')}
                >
                    <LogoComponent fallback={<div />} />
                </div>
            </a>
        </div>
    );
}

function getLoggedOutLogo(languageCode: string) {
    switch (languageCode) {
        case 'en':
            return LoggedOutLogoEN;
        case 'de':
            return LoggedOutLogoDE;
        case 'it':
            return LoggedOutLogoIT;
        case 'pt':
            return LoggedOutLogoPT;
        case 'fr':
            return LoggedOutLogoFR;
        case 'nl':
            return LoggedOutLogoNL;
        case 'es':
            return LoggedOutLogoES;
        default:
            return LoggedOutLogoEN;
    }
}

function getLoggedInLogo(languageCode: string) {
    switch (languageCode) {
        case 'en':
            return LoggedInLogoEN;
        case 'de':
            return LoggedInLogoDE;
        case 'it':
            return LoggedInLogoIT;
        case 'pt':
            return LoggedInLogoPT;
        case 'fr':
            return LoggedInLogoFR;
        case 'nl':
            return LoggedInLogoNL;
        case 'es':
            return LoggedInLogoES;
        default:
            return LoggedInLogoEN;
    }
}
